import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export default function Pricing() {
  const navigate = useNavigate()

  useEffect(() => {
    navigate('/join', { replace: true })
  }, [navigate])

  return null
}
